import { render, staticRenderFns } from "./SumBox.vue?vue&type=template&id=7fe32229&scoped=true"
import script from "./SumBox.vue?vue&type=script&lang=js"
export * from "./SumBox.vue?vue&type=script&lang=js"
import style0 from "./SumBox.vue?vue&type=style&index=0&id=7fe32229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe32229",
  null
  
)

export default component.exports